<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.calculation.algorithm' | translate }}</label>
    <select appSelect [collection]="algorithmList" formControlName="calculationStructureInternalName">
    </select>
  </app-input-group>
</form>

@if (activeDescription) {
  <app-alert type="info">
    {{ activeDescription | translate }}
  </app-alert>
}

@for (item of rowHandler; track index; let index = $index) {
  @if (algorithmForholdsfordelt && index === 2) {
    <p class="text-xs font-medium text-gray-500 mt-3 mb-1">
      {{ 'meteringpoint.calculation.summaling' | translate }}
    </p>
  }
  <app-input-group>
    <label appLabel>{{ item.name || item.internalName }}</label>
    <div class="flex gap-2">
      <div class="flex-grow">
        <input appInput inputmode="numeric" pattern="[0-9]*" [(ngModel)]="item.meteringPointIdentification"
               [placeholder]="'meteringpoint.calculation.definemp' | translate">
      </div>
      @if (algorithmDynamic || (algorithmForholdsfordelt && index >= 2)) {
        <div>
          <button class="flex justify-center items-center h-[38px] w-[38px] rounded bg-red-500 text-white"
                  (click)="removeRow(index)">
            <lucide-icon size="16" [name]="Trash"></lucide-icon>
          </button>
        </div>
      }
    </div>
  </app-input-group>
}

@if (algorithmDynamic || algorithmForholdsfordelt) {
  <button type="button" class="flex items-center gap-1 text-sm text-theme-primary hover:underline mt-1" (click)="addRow()">
    <lucide-icon size="14" [name]="Plus"></lucide-icon>
    {{ 'meteringpoint.calculation.addmeteringpoint' | translate }}
  </button>
}
